module.exports = __webpack_public_path__ + "images/66a1924725a9b61454e20c1bdcc9de44.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/8.png
// module id = 384
// module chunks = 0